export default {
  data(){
    return {
      isParkEntrance        : true,
      parkTourTemplateType  : 'entrance', // [enterd | entrance]

      parkTutorial          : {
        options : {
          useKeyboardNavigation: false,
          labels: {
            buttonSkip: 'スキップ',
            buttonPrevious: '前へ',
            buttonNext: '次へ',
            buttonStop: '終了する'
          }
        },

        callbacks : {
          onSkip : () => {
            this.$store.dispatch({
              type  : 'tutorial/updateSingleShouldOpenTour',
              name  : 'park',
              value : false
            });
          },

          onFinish : () => {
            this.$store.dispatch({
              type  : 'tutorial/updateSingleShouldOpenTour',
              name  : 'park',
              value : false
            });

            if(this.tourType === 'through'){
              this.$store.dispatch({
                type  : 'tutorial/updateShouldOpenTour',
                name  : 'connection'
              });
            }
          }
        },

        steps : [],

        stepsTemplateUnEnter : [
          {
            target: '.icon-slot-park',
            content: `こちらはひろばで御座います。様々に広がるひろばへ思い思いのノートを掲示する事が可能で御座います。`
          },
        ],

        stepsTemplateEntered : [
          {
            target: '.icon-slot-park',
            content: `こちらはひろばで御座います。`
          },
        ],
      }
    }
  },

  watch : {
    parkTourTemplateType : {
      handler(value){
        switch(value){
          case 'enterd':
            this.parkTutorial.steps = this.parkTutorial.stepsTemplateEntered;
          break;

          case 'entrance':
            this.parkTutorial.steps = this.parkTutorial.stepsTemplateUnEnter;
          break;
        }
      },
      immediate: true
    },

    characterMetaData : {
      handler(data){
        if(data === {}) return;

        this.isParkEntrance = this.characterMetaData['parks.showEntrance'];
      },
      deep: true
    },

    tourType : {
      handler(value){
        // let newSteps = [];
        let stopButtonLabel = '終了する';

        switch(value){
          case 'single':
            // newSteps = this.officeTutorial.stepsTemplate.slice(0, 7);

            stopButtonLabel = '終了する';
          break;

          case 'through':
            // newSteps = this.officeTutorial.stepsTemplate.slice(0, 8);

            stopButtonLabel = '次へ';
          break;
        }

        // this.officeTutorial.steps = newSteps;
        this.parkTutorial.options.labels.buttonStop = stopButtonLabel;
      },
      immediate: true,
      deep: true
    }
  }
}